<template>
  <div>
    <SvgModal ref="svgModal" @add-cart="addEventToCart"></SvgModal>
    <div v-for="(item) in events" :key="item.activityId" class="card shadow-sm mb-4">
      <div class="row">
        <div class="col-md-3 container-img">
          <img :src="verifyImage(item.images)" class="card-img" alt="img" />
        </div>
        <div class="col-md-6">
          <div class="card-body">
            <h5 class="card-title">
              <b>{{ item.title }}</b>
              <!-- <span> - </span> -->
              <!-- <a href="#">Ver info</a> -->
            </h5>
            <p class="card-text" v-html="truncateHtml(item.description, 300)"></p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card-body pl-0">
            <router-link :to="{ name: 'CashlessPoints', params: { eventId: item.activityId } }"
              class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'cashlessBO')">
              Venta puntos
            </router-link>
            <router-link :to="{ name: 'CashlessRecharge', params: { eventId: item.activityId } }"
              class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'cashlessBO')">
              Reporte de recargas
            </router-link>
            <router-link :to="{ name: 'ReportPoints', params: { eventId: item.activityId } }"
              class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'cashlessBO')">
              Reporte puntos
            </router-link>
            <button class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'merchandiseBO')"
              @click="selectMetaDataEvent(item)">
              Venta productos
            </button>
            <router-link :to="{ name: 'Reports', params: { eventId: item.activityId } }"
              class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'merchandiseBO')">
              Reporte productos
            </router-link>
            <!-- <button class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'callcenter')"
              @click="reservateMeet(item)">
              Reservar cita
            </button>
            <router-link class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'callcenterUnilabs')"
              :to="{ name: 'Unilabs', params: { eventId: item.activityId } }">
              Reservar cita
            </router-link> -->
            <button class="btn btn-outline-dark btn-block mb-2" v-if="getMetadataValue(item.metadatas,'btn_feePayments')"
              @click="payRemainingParts(item)">
              Pagar partes restantes
            </button>
          </div>
        </div>
      </div>
      <div v-if="!getMetadataValue(item.metadatas,'callcenter') && ! getMetadataValue(item.metadatas,'callcenterUnilabs') && !roleUser">
        <div class="card border-left-0 border-right-0">
          <div @click="handleClick(item)" class="card-header text-primary" style="cursor:pointer">
            <b>Fechas disponibles</b>
            <div class="float-right">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <b-collapse v-model="item.isCollapsedOpen" :id="`c-event-${item.activityId}`" accordion="accordion-events">
            <EventsListDates
              :item="item"
              :dates="item.dates"
              :eventSelected="eventSelected"
              @eventSelected="$emit('eventSelected', $event)"
              @updateEventSelected="updateEventSelected($event)"
              @addEventToCart="(...props) => addEventToCart(...props)"
              @initSvgModal="initSvgModal" />
          </b-collapse>
        </div>
      </div>
    </div>
    <b-modal v-model="modalUnilabs" :title="eventMeet.title" no-close-on-backdrop no-close-on-esc hide-footer>
      <UnilabsForms v-if="modalUnilabs" :eventData="eventMeet" @ok="modalUnilabs = false"></UnilabsForms>
    </b-modal>
    <ModalPayRemainingParts ref="modalPayRemainingParts" :eventId="eventId" />
  </div>
</template>

<script>
import api from '../api';
import EventsListDates from './EventsListDates.vue';
export default {
  components: { EventsListDates },
  props: ['events'],
  data() {
    return {
      currencyIso: null,
      modalUnilabs: false,
      eventMeet: {},
      eventId: null,
      eventSelected: {
        date: null,
        hour: null,
        event: null
      }
    };
  },
  computed: {
    cart() {
      return this.$store.state.cart.cartEvents;
    },
    roleUser() {
      return this.$store.state.auth.roles.some(role => role.name === "supervisor_boleteria");
    },
  },
  methods: {
    verifyImage(images) {
      return (images && images.original) ? images.original : 'https://fakeimg.pl/168x106/';
    },
    selectMetaDataEvent(event) {
      this.$store.dispatch('addMetadata', event.metadatas);
      this.$router.push({ name: 'Products', params: { eventId: event.activityId } });
    },
    payRemainingParts(event) {
      if (event !== undefined) {
        this.eventId = event.activityId;
        this.$store.dispatch('addMetadata', event.metadatas);
        this.$refs.modalPayRemainingParts.show()
      }
    },
    reservateMeet(item) {
      this.eventMeet = item;
      this.modalUnilabs = true;
    },
    initSvgModal(type) {
      const { event, hour } = this.eventSelected;
      this.$refs.svgModal.init(hour, type, event);
      this.$store.dispatch('addMetadata', event.metadatas);
    },
    addEventToCart(ticketType, isRemove) {
      const { event, hour, date } = this.eventSelected;

      const { metadatas } = event;
      this.$store.dispatch('addMetadata', metadatas);
      this.$store.dispatch('addMerchandiseBO', this.getMetadataValue(metadatas,'merchandiseBO'));

      const newTicketType = {
        ...event, ...ticketType,
        ...hour, ...date,
        adhId: hour.dateHourId,
        imageUrl: this.verifyImage(event.images),
        price: Number(Number(ticketType.price).toFixed(2))
      };

      if (this.currencyIso && this.currencyIso !== newTicketType.currency && this.cart.length > 0) {
        const msg = 'Sólo puedes agregar al carrito, eventos de una misma moneda.';
        this.$bvToast.toast(msg, {
          title: 'NOTA',
          solid: true,
          variant: 'danger',
          autoHideDelay: 7000
        });
        return;
      }
      this.currencyIso = newTicketType.currency;
      const cartClon = [...this.cart];
      const index = this.cart.findIndex(
        (obj) => newTicketType.adhId === obj.adhId && newTicketType.ticketTypeId === obj.ticketTypeId
      );
      if (!isRemove) {
        if (index === -1) {
          cartClon.push(newTicketType);
        } else {
          cartClon[index] = newTicketType;
        }
      } else if (!newTicketType.value) {
        cartClon.splice(index, 1);
      } else {
        cartClon[index] = newTicketType;
      }
      this.$emit('update-cart', cartClon);
      this.$emit('eventSelected', event);
      this.successToast();
    },
    successToast() {
      const h = this.$createElement
      const id = `my-toast-${this.count++}`
      const $content = h(
        'span',
        {
          on: { click: () => this.$bvToast.hide(id) },
        },
        [
          h('span', 'Se añadio con éxito al carrito, para finalizar la venta, clic en el "Carrito"'),
          h('i', { class: 'material-icons' }, 'shopping_cart')
        ]
      )
      this.$bvToast.toast([$content], {
        title: 'Éxito',
        variant: 'success',
        toaster: 'b-toaster-bottom-center',
        solid: true,
      })
    },
    async handleClick(item) {
      this.eventSelected.event = null;
      if (!item.isCollapsedOpen) {
        await this.getListDates(item);
      } else {
        item.isCollapsedOpen = false;
      }
    },
    async getListDates(item) {
      item.dates = [];
      this.eventSelected.date = null;
      this.eventSelected.hour = null;
      this.eventSelected.event = item;
      try {
        this.$store.dispatch('changeLoadingJoinnus', true);
        item.dates = await api.getListSchedules(item.activityId);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        item.isCollapsedOpen = item.dates.length > 0;
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    updateEventSelected(event) {
      const { date, hour } = event;
      this.eventSelected.date = date;
      this.eventSelected.hour = hour;
    }
  }
};
</script>
